import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProfitLossReportService } from '../service/profit-loss-report.service';
import { ProfitAndLossReportInfo, ProfitAndLossParam } from '../model/profit-loss-report.model';

import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';   // 👈 v2 API
import { Label } from 'ng2-charts';                                  // 👈 v2 API
import { ElementRef } from '@angular/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-profit-loss-report',
  templateUrl: './profit-loss-report.component.html',
  styleUrls: ['./profit-loss-report.component.css']
})
export class ProfitLossReportComponent implements OnChanges {
  /** ─────────── Filter ─────────── */
  form: FormGroup;
  projectCodeList: string[] = [];
  projectNameList: string[] = [];
  managerNameList: string[] = [];

  /** ─────────── Result ─────────── */
  @Input() projectCode = '';

  
  report: ProfitAndLossReportInfo | null = null;
  isLoading = false;

  effortSoldTotal   = 0;
  effortActualTotal = 0;
  effortCostDiffTotal = 0;

  indirectCostTotal = 0;
  /** ─────────── Chart (ng2-charts v2) ─────────── */
  chartType: ChartType = 'bar';
  chartLabels: Label[] = [];                 // <─ labels แยกต่างหาก
  chartData: ChartDataSets[] = [];           // <─ datasets array
  chartOptions: ChartOptions = {
    responsive: true,
    scales: {
    xAxes: [{ stacked: true }],   // ★ ซ้อนตามแกน X
    yAxes: [{ stacked: true, ticks: { beginAtZero: true } }]
    },
    legend: { display: false },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'top',
        formatter: (v: number) => v.toLocaleString()
      }
    }
  };
  fromMonth: string | null = null;   
  toMonth:   string | null = null;
  applyMonthRange(): void {
    let fromDate: string | undefined;
    let toDate:   string | undefined;

    if (this.fromMonth && this.toMonth) {
      // ถ้าเลือกสลับ ให้สลับคืน
      if (this.fromMonth > this.toMonth) {
        const t = this.fromMonth; this.fromMonth = this.toMonth; this.toMonth = t;
      }
      const [fy, fm] = this.fromMonth.split('-').map(Number);
      const [ty, tm] = this.toMonth.split('-').map(Number);

      // from = วันแรกของเดือน From
      fromDate = new Date(Date.UTC(fy, fm - 1, 1)).toISOString().slice(0, 10);
      // to = วันสุดท้ายของเดือน To (inclusive)
      toDate   = new Date(Date.UTC(ty, tm, 0)).toISOString().slice(0, 10);
    }

    this.loadReport(fromDate, toDate);
  }

// Clear ตัวกรอง -> ล้างค่าและโหลดแบบไม่กรอง
  clearMonthRange(): void {
    this.fromMonth = null;
    this.toMonth   = null;
    this.loadReport(); // ไม่มี from/to
  }

  constructor(private fb: FormBuilder,
              private service: ProfitLossReportService,
              private el: ElementRef) {

    this.form = this.fb.group({
      projectCode : this.projectCode,
      projectName : [null],
      managerName : [null]
    });
  }

  ngOnChanges(ch: SimpleChanges): void {
    console.log('Project Code changed:', this.projectCode);
    console.log('Project Code changed:', ch.projectCode);
    if (ch.projectCode && this.projectCode) {
      

      this.loadReport();
    }
  }

  // ngOnInit(): void {
  //   console.log(this.projectCode);
  //   // this.loadDropdowns();
  //   // if (this.projectCode) {
  //     this.loadReport();
  //   // }
  // }

  private loadReport(fromDate?: string, toDate?: string): void {
  

    const param: ProfitAndLossParam = {
      projectCode: this.projectCode,
      projectName: '',
      managerName: ''
    };

      // ส่งเฉพาะเมื่อมีค่า (ปล่อยว่าง = ไม่กรอง)
    if (fromDate) param.fromDate = fromDate;
    if (toDate)   param.toDate   = toDate;

    this.isLoading = true;

    this.service.getProfitAndLossReport(param).subscribe(res => {
      this.report = res;
      this.buildChart();          // ⬅️ เตรียมกราฟตามผลลัพธ์

      const list = res.EffortSummary ?? [];
      this.effortSoldTotal   = list.reduce((s, x) => s + (x.SoldCost   || 0), 0);
      this.effortActualTotal = list.reduce((s, x) => s + (x.ActualCost || 0), 0);
      this.effortCostDiffTotal = this.effortSoldTotal - this.effortActualTotal;

      this.indirectCostTotal =  (res.ProjectCost_InDirect  ?? 0) +
                                (res.LabourCost_InDirect   ?? 0) +
                                (res.SaleCost_InDirect     ?? 0);

      this.isLoading = false;
    });
  }

  onClear(): void {
    // this.param = {};           // รีเซตตัวกรอง
    this.form.reset?.();       // ถ้าใช้ Reactive Forms
  }
  loadDropdowns(): void {
    this.service.getProjectList().subscribe((res: any) => {
      this.projectCodeList = (res.projectCodes  ?? []).filter(code => !!code?.trim());
      this.projectNameList = (res.projectNames  ?? []).filter(name => !!name?.trim());
      this.managerNameList = (res.managerNames ?? []).filter(mgr  => !!mgr?.trim());
    });
  }

  /* ------------------- search ------------------- */
  search(): void {
    const param: ProfitAndLossParam = this.form.value;
    this.isLoading = true;

    this.service.getProfitAndLossReport(param).subscribe(res => {
      this.report = res;
      this.buildChart();          // ⬅️ เตรียมกราฟตามผลลัพธ์

      const list = res.EffortSummary ?? [];
      this.effortSoldTotal   = list.reduce((s, x) => s + (x.SoldCost   || 0), 0);
      this.effortActualTotal = list.reduce((s, x) => s + (x.ActualCost || 0), 0);
      this.effortCostDiffTotal = this.effortSoldTotal - this.effortActualTotal;

      this.indirectCostTotal =  (res.ProjectCost_InDirect  ?? 0) +
                                (res.LabourCost_InDirect   ?? 0) +
                                (res.SaleCost_InDirect     ?? 0);

      this.isLoading = false;
    });
  }

  private buildChart(): void {
    if (!this.report) { return; }

    this.chartLabels = [
      'Revenue',
      'Project Cost',
      'Labour Cost',
      'Sale Cost'
    ];

    this.chartData = [
      {
        label: 'Direct',
        backgroundColor:  ['#2ecc71', '#3498db', '#3498db', '#3498db'],
        data: [
          this.report.Revenue                ?? 0,
          this.report.ProjectCost_Direct     ?? 0,
          this.report.LabourCost_Direct      ?? 0,
          this.report.SaleCost_Direct        ?? 0
        ],
        order: 1
      },
      {
        label: 'Indirect',
        backgroundColor: ['transparent', '#f1c40f', '#f1c40f', '#f1c40f'],
        data: [
          0,
          this.report.ProjectCost_InDirect   ?? 0,
          0,
          this.report.SaleCost_InDirect      ?? 0
        ],
        order: 2
      }
    ];
  }

  exportPdf(): void {
    const target = this.el.nativeElement.querySelector('#reportContent') as HTMLElement;
    if (!target) { return; }

    /* ให้เวลากราฟ/ฟอนต์ render เต็มก่อนจับภาพ */
    setTimeout(() => {
      html2canvas(target, { scale: 2, useCORS: true }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');

        /* คำนวณสัดส่วนให้พอดีหน้า */
        const pageWidth  = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgRatio   = canvas.width / canvas.height;
        const pdfWidth   = pageWidth - 20;              // margin 10 mm ซ้าย-ขวา
        const pdfHeight  = pdfWidth / imgRatio;

        pdf.addImage(imgData, 'PNG', 10, 10, pdfWidth, pdfHeight);
        pdf.save(`Profit-Loss-${new Date().toISOString().slice(0,10)}.pdf`);
      });
    }, 200);   // 0.2 s
  }
}
